/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Delete_GuideInputs */

const en_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Guide`)
};

const fr_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le guide`)
};

const de_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschanleitung`)
};

const it_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina Guida`)
};

const ru_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство по удалению`)
};

const es_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía de eliminación`)
};

const zh_cn2_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除指南`)
};

const ja_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドを削除`)
};

const hi_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिलीट गाइड`)
};

const pt_pt2_knp_guide_delete_guide = /** @type {(inputs: Knp_Guide_Delete_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia de Exclusão`)
};

/**
* | output |
* | --- |
* | "Delete Guide" |
*
* @param {Knp_Guide_Delete_GuideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_guide = /** @type {((inputs?: Knp_Guide_Delete_GuideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_GuideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_delete_guide(inputs)
	if (locale === "de") return de_knp_guide_delete_guide(inputs)
	if (locale === "it") return it_knp_guide_delete_guide(inputs)
	if (locale === "ru") return ru_knp_guide_delete_guide(inputs)
	if (locale === "es") return es_knp_guide_delete_guide(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_delete_guide(inputs)
	if (locale === "ja") return ja_knp_guide_delete_guide(inputs)
	if (locale === "hi") return hi_knp_guide_delete_guide(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_delete_guide(inputs)
	return en_knp_guide_delete_guide(inputs)
});